import gsap from 'gsap'
import App from '../App'

export default class Menu {
    constructor() {
        this.menuOpen = false
        this.isAnimating = false

        this.bindMethods()
        this.getElems()
        this.setSizes()
        this.addEvents()
        this.onPageChange({
            href: window.location.href
        })
    }

    setSizes() {
        if (!this.items) return

        let height = 0

        for (let i = 0; i < this.items.length; i++) {
            const eltHeight = this.items[i].querySelector('.infinite-text__item').offsetHeight

            height = eltHeight > height ? eltHeight : height
        }

        gsap.set(this.items, {
            height
        })
    }

    bindMethods() {
        this.toggle = this.toggle.bind(this)
        this.close = this.close.bind(this)
    }

    getElems() {
        this.menu = document.body.querySelector('.menu')
        this.items = this.menu.querySelectorAll('.menu__item')
        this.titles = this.menu.querySelectorAll('.infinite-text__wrapper')
        this.menuBackground = this.menu.querySelector('.menu__background')
        this.toggler = document.body.querySelector('.header__toggler')
        this.logo = document.body.querySelector('.header__logo')
    }

    addEvents() {
        if (!App.isMobile) this.toggler && this.toggler.addEventListener('click', this.toggle)
        if (App.isMobile) this.toggler && this.toggler.addEventListener('touchstart', this.toggle)
        this.logo && this.logo.addEventListener('click', this.close)
    }

    onPageChange(location) {
        this.menuOpen = false

        if (this.currentItem) this.currentItem.classList.remove('active')

        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].href === location.href) {
                this.currentItem = this.items[i]
                this.currentItem.classList.add('active')
            }
        }
    }

    /**
     * Toggle Menu to open or close it
     * @returns {any} null
     */
    toggle() {
        if (this.isAnimating) return

        if (this.menuOpen) this.close()
        else this.open()
    }

    /**
     * Open Menu
     * @returns {Promise} return Promise when open animation end
     */
    open() {
        return new Promise((resolve) => {
            this.menuOpen = true
            App.smoothScroll.stop()

            const tl = gsap.timeline({
                onStart: () => {
                    document.body.classList.add('menu-open')
                    this.isAnimating = true
                }
            })

            tl.to(this.menuBackground, {
                alpha: 1,
                duration: 0.6,
                ease: 'power2.out',
                onComplete: () => {
                    this.isAnimating = false

                    resolve()
                }
            }, 'start')

            tl.to(this.titles, {
                alpha: 1,
                duration: 1,
                ease: 'power2.out'
            })
        })
    }

    /**
     * Close Menu
     * @returns {Promise} return Promise when close animation end
     */
    close() {
        return new Promise((resolve) => {
            const tl = gsap.timeline({
                onStart: () => {
                    this.menuOpen = false
                    this.isAnimating = true
                },
                onComplete: () => {
                    this.isAnimating = false
                    App.smoothScroll.start()

                    resolve()
                }
            })

            tl.to(this.titles, {
                alpha: 0,
                duration: 0.8,
                ease: 'power2.out',
                stagger: 0.025
            })

            tl.to(document.body, {
                duration: 0,
                onComplete: () => {
                    document.body.classList.remove('menu-open')
                }
            })

            tl.to(this.menuBackground, {
                alpha: 0,
                duration: 0.8,
                ease: 'power2.out'
            }, '0.8')
        })
    }

    resize() {
        this.setSizes()
    }

	scroll() {}
}



// WEBPACK FOOTER //
// ./scripts/util/Menu.js